export default __webpack_public_path__ + "static/media/user-profile.0934c983.svg";